import styled from 'styled-components';
import {lightColor} from '@ey/styled-theme';

const EditUserPermissionsWrapper = styled.section`
	.Userloadingstyle {
		height: calc(100vh - var(--px-191)) !important;
	}

	.inputDisabled {
		opacity: 0.8;
	}

	.motif-modal-footer {
		&.footermsg {
			.footer-btn {
				display: flex;
				justify-content: end;
				gap: var(--spacing-medium);
			}
		}
	}

	& > * {
		font-size: var(--px-14);
		color: var(--neutrals-700);
	}

	.thirdpartydescription {
		padding: var(--px-10) 0 var(--px-10) 0;
		line-height: var(--px-20);
		color: var(--neutrals-900);
	}

	.addmemberwrapper {
		overflow: auto;
		padding: var(--spacing-x-large);
		height: calc(100vh - var(--px-194));
	}

	.addmemberholder {
		.ticketdetail {
			padding-top: var(--spacing-x-large);
			.description {
				padding-bottom: var(--spacing-small);
			}
			.motif-form-field {
				width: var(--px-400);
				.motif-input {
					height: var(--px-44);
				}
			}
		}

		.mainTitle {
			padding-bottom: var(--spacing-x-large);
			border-bottom: var(--px-1) solid var(--neutrals-100);
		}

		.mainSection {
			padding-bottom: var(--spacing-x-large);
			border-bottom: var(--px-1) solid var(--neutrals-100);
		}

		.status-independence-form {
			padding: var(--spacing-x-large) 0;
			width: 100%;
			display: flex;
			gap: var(--spacing-large);
			.motif-form-field {
				width: var(--px-400);
			}
		}
		.confidentiality {
			.motif-form-field {
				width: var(--px-400);
			}
		}

		.user-confid-permission {
			width: 100%;

			.checkoption-list {
				display: flex;
				flex-wrap: wrap;
				width: 100%;
				margin: 0;
				padding: 0;

				& li {
					width: 45%;
					list-style-type: none;
					margin: var(--px-8) 4% var(--px-8) 0;
					position: relative;
				}
				.motif-checkbox-label {
					width: 100%;
				}
			}
		}

		header.access-group {
			h4 {
				color: var(--neutrals-900);
				font-size: var(--px-15);
				font-weight: bold;
			}
			svg {
				margin-left: var(--px-4);
			}
		}

		header.headerchecklist {
			padding: var(--spacing-x-large) 0 var(--spacing-small) 0;
		}

		header.access-group {
			padding: var(--spacing-x-large) 0 var(--spacing-large) 0;
		}

		header.addmemberdescription {
			&.userinfo {
				padding-bottom: 0;
			}

			h4 {
				margin: 0;
				color: var(--neutrals-900);
				font-weight: bold;
				font-size: var(--px-15);
			}
		}

		header.addmemberdescription,
		header.headerchecklist,
		header.access-group {
			h4 {
				padding: 0;
				margin: 0;
				display: inline;
			}
		}

		.motif-form-field.motif-form-field-has-value .motif-label-for-text {
			top: var(--px-5);
		}

		&.motif-form-field {
			margin-bottom: 0;

			.motif-form-field {
				margin: 0;
			}
		}

		&.hidePlaceHolder:not(floating-label) label {
			color: var(--neutrals-700);
		}

		&:error {
			border: var(--px-1) solid var(--neutrals-300);
		}

		&.floating-label.hidePlaceHolder label {
			color: var(--neutrals-700);
		}

		&.hidePlaceHolder label {
			color: var(--neutrals-700);
		}

		&:not(.floating-label) label {
			font-size: var(--px-14);
		}

		&.userfirstname,
		&.userlastname {
			width: 100%;
			margin-right: var(--px-42);
		}

		&.userinitial {
			width: 100%;
			margin-right: var(--px-42);
		}

		.userfield-row.nameandemail {
			svg.note-error-icon {
				fill: var(--red-600);
			}
		}

		.accessgroupwrapper {
			.access-group svg {
				fill: var(--neutrals-1000);
			}

			&.userfield-row {
				width: 100%;
				margin-top: 0;

				svg.note-error-icon {
					fill: var(--red-600);
				}

				.accessgroup {
					.react-select__input {
						color: var(--neutrals-1000);
					}

					.react-select-container
						.react-select__control
						.react-select__value-container.react-select__value-container--is-multi {
						padding-top: var(--px-20);
					}
				}
			}

			.react-select__menu {
				z-index: 9999;
			}
		}
	}
`;

export default EditUserPermissionsWrapper;
